import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {ToastService} from "../../services/Toast.service";
import {Router} from "@angular/router";
import {LogoService} from "../../services/LogoService";
import {LoadingService} from "../../services/LoadingService";
import {TOAST_TYPE} from "../../constants/Tpiq.constants";
import {TaxPlanningService} from "../../tpiq-services/tax-planning.service";
import {Session} from "../../services/Session";
import {TpiqSelectDropdownComponent} from "../../input-search/tpiq-select-dropdown/tpiq-select-dropdown.component";
import {FormatAmountPipe} from "../../pipes/format-amount.pipe";
import {ModelBasedNumeral} from "../../directives/model-numeral";

declare let _: any;

@Component({
  selector: 'app-roi-page',
  standalone: true,
  imports: [CommonModule, FormsModule, ModelBasedNumeral, TpiqSelectDropdownComponent, FormatAmountPipe],
  templateUrl: './roi-page.component.html',
  styleUrl: './roi-page.component.scss'
})
export class RoiPageComponent implements OnInit, OnDestroy {
  org: string;
  user: any;
  orgName: string;
  orgLogo: string;
  backgroundColor: string;
  minimizedSections: Array<any> = [];
  @Input() roiData: any;
  @Input() taxYear: any;
  @Input() bgColor: any;
  @Input() taxPlanId: any;
  @Input() showStrategyLink: boolean;
  @Input() filterOptions: any;
  @Input() readOnly: any;
  @Input() displayLogo: any;
  @Input() hasActualAmount: boolean;

  @Output() triggerNavigateToStrategyOverview: EventEmitter<any> = new EventEmitter<any>();
  @Output() triggerToRefreshRoiData: EventEmitter<any> = new EventEmitter<any>();
  @Output() navigateToAddFees: EventEmitter<void> = new EventEmitter<void>();

  destroy$: EventEmitter<void> = new EventEmitter<void>();
  isCustomer: any;
  reveal: any = {
    roiFees: false
  };
  roiEditFees: any;
  roiCustomize: any;
  roiCustomizations: any = [{name: 3}, {name: 4}, {name: 5}, {name: 6}, {name: 7}, {name: 8}, {name: 9}, {name: 10}];
  defaultROICustomization: any = 10;
  logoBg: any;

  constructor(
    private _router: Router,
    private logoService: LogoService,
    private taxPlanningServie: TaxPlanningService,
    private loadingService: LoadingService,
    private taxPlanningService: TaxPlanningService,
    private toastService: ToastService,
  ) {}

  ngOnInit(): void {
    this.org = Session.getOrg();
    this.user = Session.getUser('delegatedFrom');
    this.isCustomer = this.user.isCustomer;
    this.orgName = this.user.org || '';
    this.orgLogo = this.logoService.getLoginLogoUrl();
    this.logoBg = {
      background: 'url("' + this.orgLogo + '") center center no-repeat',
      'background-size': 'contain'
    };
    this.backgroundColor = this.bgColor ? this.bgColor : '#fff';
    if (this.roiData && this.roiData.minimizedSections) {
      this.minimizedSections = _.compact(this.roiData.minimizedSections);
      }
    if (!this.filterOptions) {
      this.filterOptions = {
        actual: false,
        dollarChange: false,
        percentageChange: false
      };
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  minimizeOrMaximizeSection(sectionName, type?, index?) {
    let section = sectionName;
    if (index && index != -1) {
      section += index;
    }
    this.minimizedSections.push(section);
    this.minimizedSections = _.uniq(this.minimizedSections);
    if (type == 'remove') {
      _.remove(this.minimizedSections, function(item) {
        return item == section;
      });
    }
    this.minimizedSections = [...this.minimizedSections];

    this.saveMinimizedSectionsOfROI();
  }

  showAllHiddenSections() {
    this.minimizedSections = [];
    this.saveMinimizedSectionsOfROI();
  }

  saveMinimizedSectionsOfROI() {
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.updateROIMinimizedSections(this.org, this.user.id, this.taxPlanId, this.minimizedSections.toString())
      .subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.error, 'Failed to perform operation');
      });
  }

  openStrategySinglePage(taxSave) {
    this.triggerNavigateToStrategyOverview.emit(taxSave);
  }

  hideReveal(key){
    this.reveal[key] = false;
  }

  editRoiFees() {
    this.reveal.roiFees = true;
    this.roiEditFees = _.cloneDeep(this.roiData.costlines);
  }

  updateRoiFees() {
    if (this.roiEditFees) {
      let feesData = _.cloneDeep(this.roiEditFees);
      if (feesData && feesData.length > 0) {
        _.each(feesData, function (feeItem) {
          if (feeItem.frequency == 'Monthly') {
            feeItem.amount = _.round(feeItem.amount / 12);
          }
        });
      }
      this.loadingService.triggerLoadingEvent(true);
      this.taxPlanningService.updateCostLines(this.org, this.user.id, this.taxPlanId, feesData)
        .subscribe({
          next: (response) => {
            this.loadingService.triggerLoadingEvent(false);
            this.toastService.pop(TOAST_TYPE.success, 'Fees updated successfully');
            this.hideReveal('roiFees');
            this.triggerToRefreshRoiData.emit();
          },
          error: (error) => {
            this.loadingService.triggerLoadingEvent(false);
            this.toastService.pop(TOAST_TYPE.success, 'Failed to update Fees');
          }
        });
    }
  }

  editROIForCustomize() {
    this.roiCustomize = true;
  }

  setRoiCustomization(customization) {
    this.defaultROICustomization = customization.name;
    this.roiCustomize = false;
    this.triggerToRefreshRoiData.emit({roiCustomizedYear: this.defaultROICustomization});
  }

  ngOnChanges(changes): void {
    if (changes.roiData) {
      this.roiCustomize = false;
    }
    if (changes.roiData && !changes.roiData.currentValue.customizedYear) {
      this.defaultROICustomization = 10;
    }
  }

  onUnlimitedNoFeesClick() {
    this.navigateToAddFees.emit();
  }

}
